import styled from "styled-components";
import { breakpoints } from "../styles/variables";

export const LandingPageWrapper = styled.div``;

export const PageWrapper = styled.div`
    position: relative;
    overflow: hidden;
`;

const PageContainer = styled.div`
    max-width: ${breakpoints.xl};
    margin: 2rem auto 0 auto;
    padding: 0 1rem;
    @media (min-width: ${breakpoints.xl}) {
        padding: 0;
        margin: 0 auto;
    }
`;
export const PageTopLinearBg = styled.div`
    position: absolute;
    top: 200px;
    left: -120px;
    width: 300px;
    height: 300px;
    transform: rotate(58.618deg);
    flex-shrink: 0;
    border-radius: 300px;
    background: transparent;
    @media (max-width: ${breakpoints.sm}) {
        top: 240px;
        left: -150px;
        transform: scale(0.3);
    }
    @media (max-width: ${breakpoints.md}) {
        transform: scale(0.6);
    }
`;
export const PageTopRightLinearBg = styled.div`
    position: absolute;
    top: 200px;
    right: -120px;
    width: 300px;
    height: 300px;
    transform: rotate(-1.382deg);
    flex-shrink: 0;
    border-radius: 300px;
    background: transparent;
    @media (max-width: ${breakpoints.sm}) {
        top: 240px;
        right: -150px;
        transform: scale(0.3);
    }
    @media (max-width: ${breakpoints.md}) {
        transform: scale(0.6);
    }
`;

export const PageMidLinearBg = styled.div`
    position: absolute;
    bottom: 800px;
    right: -130px;
    width: 400px;
    height: 400px;
    transform: rotate(-1.382deg);
    flex-shrink: 0;
    border-radius: 400px;
    background: transparent;
    @media (max-width: ${breakpoints.sm}) {
        bottom: 2500px;
        right: -240px;
        transform: scale(0.3);
    }
    @media (max-width: ${breakpoints.md}) {
        transform: scale(0.6);
    }
`;

export default PageContainer;
